export default __webpack_public_path__ + "8b9882b3ab04256759b9307c5ec3782a.png";